import * as input from '../input/graphql';
import { Form } from '../input/Form';
import { Navigate } from 'react-router';
import { useSuspenseQuery } from '../hooks/graphql/useQuery';
import { useMutation } from '../hooks/graphql/useMutation';

export const Input = () => {
  const { data } = useSuspenseQuery<input.Data>(input.REQUEST_QUERY);
  const [answerRequest] = useMutation<input.Data>(input.ANSWER_REQUEST);

  const request = data.request;
  if (!request) {
    return (
      <div className="l-wrap-xs u-pt100">
        <div className="l-box-message">
          <p className="m-title-sub u-pt0 u-ta-c">入力依頼がキャンセルされました。</p>
        </div>
      </div>
    );
  }

  const { status, owners } = request;
  if (status === 'completed') {
    return <Navigate to="/finished" replace />;
  }

  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">マイナンバー入力</h1>
      </div>
      <Form owners={owners} answerRequest={answerRequest} />
    </div>
  );
};
